import './Spinner.css'

const Spinner = () => {
    return (
        <div className='w-100 text-center mx-auto'>
            <div className="loadingio-spinner-spinner-v5tbn0vuwj">
                <div className="ldio-31b9mkay7un">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
            </div>
        </div>
    );
};

export default Spinner;